import announcementTypes from './announcementTypes';

export function compareAnnouncements(announcement, other) {
	return announcement.type === other.type
	&& announcement.author === other.author
	&& announcement.title === other.title;
}

export function mapAnnouncement(announcement) {
	return {
		uuid: announcement.uuid,
		type: announcement.announcement_type,
		author: announcement.author_name || announcement.author,
		title: announcement.text,
		startDate: announcement.start_date,
		endDate: announcement.end_date,
		isShown: announcement.is_shown,
		icon: getIconForAnnouncementType(announcement.announcement_type),
	};
}

function getIconForAnnouncementType(type) {
	switch (type) {
	case announcementTypes.danger:
	case announcementTypes.warning:
		return 'warning';
	case announcementTypes.success:
		return 'achievement-trophy';
	case announcementTypes.info:
		return 'info';
	}
	return '';
}
